import {CSSProperties} from 'react';
import {LOGOUT_URL} from '../utils/constants';
import {useBookingState} from '../store';
import {UaButton} from 'uppsala.ui.react';

interface LogoutButtonProps {
  readonly title: string;
  readonly style?: CSSProperties;
  readonly returnUrl?: string;
}

export default function LogoutButton(props: LogoutButtonProps) {
  const clearState = useBookingState((state) => state.clearState);

  const handleLogout = () => {
    const returnUrl = props.returnUrl ? `${window.location.origin}${props.returnUrl}` : window.location.href;
    const url = `${LOGOUT_URL}?returnUrl=${returnUrl}`;
    if (!url) throw new Error('LOGOUT_URL was undefined');

    // Clear fake login sessionStorage if it exists
    sessionStorage.removeItem('fakeLoggedIn');
    sessionStorage.removeItem('mockedPIN');
    clearState();

    window.location.href = url;
  };

  return (
    <UaButton
      title={props.title}
      icon={
        <img
          style={{marginLeft: '13px', width: '17px', height: '19px'}}
          src="/assets/icons/logout-icon.svg"
          alt="logout-icon"
        />
      }
      iconPosition="right"
      type="warning"
      size="sm"
      style={props.style}
      onClick={handleLogout}
    />
  );
}
